<template>
    <modal
        name="add-to-new-watchlist"
        height="auto"
        :adaptive="true"
        @before-open="beforeOpen"
        @before-close="beforeClose"
        ref="add-to-new-watchlist-modal"
        @opened="onOpened"
        tabindex="0"
    >
        <div class="modal">
            <span class="modal__title" v-html="$t('ModalAddNewWatchlist.name_new_watchlist')"></span>
            <div class="modal__inputs">
                <div class="modal__new-watchlist-name">
                    <span v-html="$t('ModalAddNewWatchlist.new_watchlist_name')"></span>
                    <TotemInput
                        class="modal__input"
                        type=text
                        v-model="newWatchlistName"
                        :placeholder="$t('ModalAddNewWatchlist.new_watchlist')"
                        @keyup.enter.native="addNewWatchlist"
                        tabindex="0"
                    >
                    </TotemInput>
                </div>
            </div>
            <ul class="modal__action-buttons">
                <li tabindex="0" @keyup.enter="addNewWatchlist">
                    <TotemButton
                    color="basic"
                    :fullWidth="false"
                    @click="cancelAddToWatchlist"
                    v-on:keyup.enter="cancelAddToWatchlist"
                    class="-margin-left"
                    :label="$t('ModalAddNewWatchlist.cancel_watchlist')"

                />
                </li>
                <li tabindex="0" @keyup.enter="addNewWatchlist">
                <TotemButton
                    color="primary"
                    :fullWidth="false"
                    @click="addNewWatchlist"
                    class="-margin-left"
                    :label="$t('ModalAddNewWatchlist.create_watchlist')"
                />
                </li>
            </ul>
            <span v-if="isWatchListNameEmpty" class="modal__empty-watchlist-name-notification" v-html="$t('ModalAddNewWatchlist.name_new_watchlist_notification')"></span>
        </div>
    </modal>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        data () {
            return {
                newWatchlistName: '',
                addInProgress: false
            }
        },
        computed: {
            ...mapGetters({
                currentNewElement: 'Watchlists/getCurrentNewElement',
            }),
            isWatchListNameEmpty () {
                return this.newWatchlistName === '' && this.addInProgress
            }
        },
        methods: {
            async addNewWatchlist () {
                this.addInProgress = true
                if (this.newWatchlistName === '') {
                    return
                }
                await this.$store.dispatch('Watchlists/assignNewWatchlistName', this.newWatchlistName)
                const currentNewElement = this.currentNewElement
                const watchlistName = this.newWatchlistName
                await this.$store.dispatch('Watchlists/createNewWatchListWithCurrentElement')
                await this.$store.dispatch('Watchlists/highlightElement', {
                    currentNewElement,
                    watchlistName
                })

                setTimeout(() => {
                    this.$store.dispatch('Watchlists/unHighlightElement', currentNewElement)
                }, 50)

                this.addInProgress = false
                this.newWatchlistName = ''
                this.$modal.hide('add-to-new-watchlist')
            },
            beforeOpen (event) {
                return this.$store.dispatch('Watchlists/toggleModal', true)
            },
            beforeClose (event) {
                return this.$store.dispatch('Watchlists/toggleModal', false)
            },
            cancelAddToWatchlist () {
                this.addInProgress = false
                this.newWatchlistName = ''
                this.$modal.hide('add-to-new-watchlist')
            },
            onOpened () {
                this.$refs['add-to-new-watchlist-modal'].$el.focus()
            }
        }
    }
</script>

<style lang="scss" scoped>
    .modal {
        padding: 30px 40px;
        display: flex;
        flex-direction: column;
        justify-content: center;

        &__title {
            margin: 0 0 25px;
            font-family: QuickSand-Medium, sans-serif;
            font-size: 2rem;
        }

        &__empty-watchlist-name-notification {
            color: $red_salsa;
            justify-content: start;
            align-items: start;
            margin: 10px;
        }

        &__new-watchlist-name {
            span {
                display: flex;
                align-items: center;
                width: fit-content;
            }

            display: flex;
            align-items: center;
            gap: 10px;
            font-family: Nunito-Bold, sans-serif;
        }

        &__inputs {
            display: flex;
            justify-content: center;
            flex-direction: column;
            gap: 15px;
        }

        &__input {
            border-radius: 5px;
            flex: 1;
            display: flex;
        }

        &__action-buttons {
            display: flex;
            margin: 20px 0 0px 0px;
            align-items: center;
            justify-content: flex-end;
        }
    }
</style>
